import { FC, useState } from 'react';
import DialogWrapper from '@/components/shared/DialogWrapper';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/routes/paths';
import { Button } from '@/components/ui/button.tsx';
import useCustomLoader from '@/hooks/useCustomLoader.tsx';
import { useGetInvoicesReport } from '@/api/user/user.api.ts';
import { DateRange } from 'react-day-picker';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { DATES_OPTIONS } from '@/common/constants';
import DateRangePicker from '@/components/shared/DateRangePicker.tsx';

const InvoicesReport: FC = () => {
  const navigate = useNavigate();

  const handleDismiss = () => navigate(paths.INVOICES);

  const [reportRange, setReportRange] = useState<DateRange | undefined>();
  const [dateType, setDateType] = useState('accountingDate');

  const { isLoading: isLoadingReport, response: downloadReportHandler } =
    useCustomLoader(useGetInvoicesReport());

  const handleDownloadReport = () => {
    downloadReportHandler({
      startDate: reportRange?.from || undefined,
      endDate: reportRange?.to || undefined,
      dateType: dateType,
    });
  };

  const handleFilterByChange = (value: string) => {
    setDateType(value);
  };

  return (
    <DialogWrapper
      title="Generar reporte de facturas"
      subtitle="Descarga el archivo de facturas en Excel filtrado por rango y tipo de fecha."
      className="w-full max-w-xs"
      titleClassName="text-xl"
      onDismiss={handleDismiss}
      onOverlayClick={handleDismiss}
    >
      <div>
        <div>
          <div className="w-full">
            <label className="block text-sm font-medium text-gray-700">Filtrar Por...</label>
            <Select onValueChange={handleFilterByChange}>
              <SelectTrigger className="text-muted-foreground hover:bg-accent hover:text-accent-foreground">
                <SelectValue placeholder="Seleccione el tipo de fecha" />
              </SelectTrigger>
              <SelectContent>
                {DATES_OPTIONS.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="w-full mt-4">
            <label className="block text-sm font-medium text-gray-700">Período</label>
            <DateRangePicker value={reportRange} onChange={setReportRange} />
          </div>
        </div>
        <div className="text-right mt-4">
          <Button onClick={handleDownloadReport} isLoading={isLoadingReport}>
            Descargar
          </Button>
        </div>
      </div>
    </DialogWrapper>
  );
};

export default InvoicesReport;
